import { Button } from "@designs-by-maryam/ui/components/button";
import { Link } from "@tanstack/react-router";

/**
 * 404 Not Found page component for TanStack Router.
 *
 * Displayed when a route is not found. Provides a user-friendly
 * message and navigation options to help users recover.
 *
 * Registered via the `notFoundComponent` route option on the root route.
 *
 * @see https://tanstack.com/router/latest/docs/framework/react/guide/not-found-errors
 */
export function NotFoundPage() {
	return (
		<section
			aria-live="polite"
			className="flex min-h-[50vh] flex-col items-center justify-center gap-6 px-4"
		>
			<div className="text-center">
				<h1 className="mb-2 font-bold text-6xl text-foreground">404</h1>
				<h2 className="mb-4 font-semibold text-xl text-foreground">
					Page Not Found
				</h2>
				<p className="max-w-md text-muted-foreground">
					The page you're looking for doesn't exist or has been moved. Please
					check the URL or navigate back to the homepage.
				</p>
			</div>

			<div className="flex gap-4">
				<Button onClick={() => window.history.back()} variant="outline">
					Go Back
				</Button>
				<Button asChild>
					<Link to="/">Go Home</Link>
				</Button>
			</div>
		</section>
	);
}
